// src/components/AGTUps/services/AGTUps-product-services/paymentService.js
import { api } from './config';

class PaymentService {
  /**
   * Crea un nuevo pago.
   * @param {object} paymentData - Datos del pago (title, amount, dueDate, etc.)
   * @returns {object} Respuesta del backend
   */
  static async createPayment(paymentData) {
    try {
      const response = await api.post('/payments', paymentData);
      return response.data;
    } catch (error) {
      throw new Error(`Error creating payment: ${error.message}`);
    }
  }

  /**
   * Obtiene los pagos del usuario, con opciones de filtro (status, dueDate).
   * @param {object} filters - { status, dueDate }
   * @returns {object} Respuesta del backend
   */
  static async getPayments(filters = {}) {
    try {
      // Construir parámetros de query
      const params = new URLSearchParams();
      if (filters.status) params.append('status', filters.status);
      if (filters.dueDate) params.append('dueDate', filters.dueDate);

      const url = params.toString() ? `/payments?${params.toString()}` : '/payments';
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      throw new Error(`Error fetching payments: ${error.message}`);
    }
  }

  /**
   * Actualiza un pago existente.
   * @param {string} paymentId - ID del pago a actualizar
   * @param {object} updateData - Campos a actualizar
   * @returns {object} Respuesta del backend
   */
  static async updatePayment(paymentId, updateData) {
    try {
      const response = await api.put(`/payments/${paymentId}`, updateData);
      return response.data;
    } catch (error) {
      throw new Error(`Error updating payment: ${error.message}`);
    }
  }

  /**
   * Elimina un pago existente.
   * @param {string} paymentId - ID del pago a eliminar
   * @returns {object} Respuesta del backend
   */
  static async deletePayment(paymentId) {
    try {
      const response = await api.delete(`/payments/${paymentId}`);
      return response.data;
    } catch (error) {
      throw new Error(`Error deleting payment: ${error.message}`);
    }
  }
}

export default PaymentService;
